/** Pulpit menedżera v3 (`od.v3.*`): zakres czasu, wskaźnik zdrowia, wykresy i sekcje analityczne. */
export const odV3Pl = {
  unavailableShort: 'Dane niedostępne',
  more: 'Szczegóły →',
  toolbar: {
    range: 'Zakres czasu',
    compare: 'Porównanie',
    from: 'Od',
    to: 'Do',
    invalid: 'Wybierz poprawny zakres dat (od ≤ do).',
    viewMenu: 'Widok',
    layout: 'Mój układ',
    layoutHint: 'Wybrane sekcje są zapamiętane na tym urządzeniu.',
    resetLayout: 'Pokaż wszystkie sekcje',
    presentation: 'Tryb prezentacji',
    exitPresentation: 'Zamknij prezentację (Esc)',
    exportExcel: 'Excel (CSV)',
    exportPdf: 'PDF dla zarządu',
    exported: 'Zapisano plik z danymi pulpitu.',
  },
  range: { month: 'Miesiąc', quarter: 'Kwartał', year: 'Rok', custom: 'Własny zakres' },
  compare: { prev: 'vs poprz. okres', yoy: 'vs rok temu', none: 'bez porównania' },
  sections: {
    forecast: 'Wynik i prognoza',
    sales: 'Sprzedaż i produkty',
    customers: 'Klienci i leady',
    finance: 'Finanse',
    team: 'Zespół i rentowność',
    operations: 'Operacje i system',
  },
  health: {
    title: 'Zdrowie firmy',
    aria: 'Wskaźnik zdrowia firmy: {score} na 100, {tone}',
    vsPrev: '{delta} pkt vs poprz. okres',
    noScore: 'Brak danych do oceny kondycji firmy.',
    components: 'Z czego się składa',
    how: 'Jak liczymy wskaźnik?',
    howText: 'Średnia ważona pięciu składników: sprzedaż vs cel, marża, należności, baza klientów i praca w terenie. Składnik bez danych jest pomijany, a wagi przeliczane.',
    weight: 'waga {n}%',
    tone: { ok: 'dobrze', warn: 'wymaga uwagi', bad: 'krytycznie', neutral: 'brak oceny' },
    comp: { sales: 'Sprzedaż vs cel', margin: 'Marża', receivables: 'Należności', customers: 'Baza klientów', field: 'Teren' },
  },
  pulse: {
    realization: 'Realizacja celu',
    forecast: 'Prognoza końca miesiąca',
    forecastNote: '{pct} celu',
    probability: 'Szansa na cel',
    workingDays: 'Dni robocze do końca',
    needDaily: 'potrzeba {value}/dz.',
    margin: 'Marża',
    noTarget: 'brak celu',
  },
  kpi: {
    net: 'Sprzedaż netto',
    marginAmount: '{amount} marży',
    aov: 'Średnia wartość zamówienia',
    aovNote: '{count} zamówień',
    ordersDay: 'Zamówienia / dzień',
    ordersDayNote: '{count} w zakresie',
    vsPrev: '{delta} vs poprz. okres',
    vsYoy: '{delta} vs rok temu',
  },
  main: {
    title: 'Sprzedaż w czasie',
    hint: 'Najedź na wykres, aby zobaczyć dzień; kliknij punkt, aby go przypiąć.',
    tabs: { cum: 'Narastająco', margin: 'Marża', yoy: 'Rok do roku' },
    tabsAria: 'Rodzaj wykresu',
    metricAria: 'Miara na wykresie',
    metric: { net: 'Sprzedaż netto', margin: 'Marża', orders: 'Zamówienia' },
    legend: { actual: 'Rzeczywiste', forecast: 'Prognoza', band: 'Pasmo 80%', target: 'Cel', prev: 'Poprz. okres', yoy: 'Rok temu', daily: 'Dziennie', prevYear: 'Poprz. rok', margin: 'Marża %', avg: 'Średnia' },
    rangeNote: 'Cel i prognoza dotyczą bieżącego miesiąca — dla tego zakresu pokazujemy wartości narastająco z porównaniem.',
    metricNote: 'Cel i prognoza są dostępne tylko dla sprzedaży netto.',
    aria: 'Wykres: {title}. {summary}',
    summary: 'Do dziś {value}, dni w zakresie: {days}.',
    tip: { vsTarget: 'vs cel', vsCompare: 'vs porównanie', daily: 'Dziennie', cumulative: 'Narastająco' },
    picked: 'Dzień {date}: {metric} {value}, narastająco {cum}.',
    empty: 'Brak danych dla wybranego zakresu.',
  },
  scen: {
    title: 'Scenariusze końca miesiąca',
    pessimistic: 'Pesymistyczny',
    base: 'Bazowy',
    optimistic: 'Optymistyczny',
    ofTarget: '{pct} celu',
    chance: 'szansa {pct}',
    need: 'Do celu brakuje {missing}. Przy średniej {avg}/dz. potrzebujesz {req}/dz. przez {days} dni roboczych ({over} ponad tempo).',
    needShort: 'Do celu brakuje {missing}; potrzebujesz {req}/dz. przez {days} dni roboczych.',
    reached: 'Cel miesiąca jest już osiągnięty — każda kolejna sprzedaż to nadwyżka.',
    noTarget: 'Brak celu na ten miesiąc — scenariusze pokazują tylko prognozę sprzedaży.',
  },
  sales: {
    groups: { title: 'Grupy produktów', hint: 'sprzedaż · marża · zmiana', empty: 'Brak sprzedaży w grupach.', margin: 'marża {pct}' },
    pareto: {
      title: 'Struktura klientów (ABC / Pareto)',
      hint: 'koncentracja top 10 = {pct}',
      aria: 'Krzywa Pareto: udział sprzedaży wg udziału klientów',
      note: '20% klientów ({count}) daje {pct} sprzedaży. Do 50% sprzedaży wystarczy {n50} klientów.',
      toneOk: 'w normie',
      toneWarn: 'podwyższona',
      toneBad: 'wysoka koncentracja',
      threshold: 'Próg ostrzegawczy koncentracji: 50% (top 10).',
      cum: 'Skumulowana sprzedaż',
      customersPct: '% klientów',
    },
    heat: { title: 'Sezonowość: kiedy sprzedajemy', hint: 'dzień tygodnia × tydzień', less: 'mniej', more: 'więcej', aria: 'Mapa ciepła sprzedaży: dzień tygodnia i tydzień', cell: '{day}, tydz. od {week}: {value}' },
    next: { title: 'Prognoza na kolejne miesiące', hint: 'pasmo 80%', aria: 'Prognoza sprzedaży na kolejne miesiące z pasmem 80%', value: 'Prognoza', low: 'Dolna granica', high: 'Górna granica', empty: 'Brak prognozy.' },
  },
  customers: {
    flow: { title: 'Kondycja bazy klientów', hint: '12 mies.', aria: 'Przepływ klientów: nowi, utraceni, odzyskani', newC: 'Nowi', lost: 'Utraceni', recovered: 'Odzyskani', net: 'Saldo' },
    cohort: { title: 'Retencja kohort', hint: '% klientów wracających', size: 'Klientów', month: 'M{n}', avg: 'Średnia retencja po 3 mies.: {pct}', empty: 'Za mało danych do kohort.' },
    churn: { title: 'Zagrożeni odejściem', hint: 'kwota ryzyka {amount}', empty: 'Brak klientów zagrożonych odejściem.', more: 'Klienci →', band: { HIGH: 'wysokie', MEDIUM: 'średnie', LOW: 'niskie' } },
    funnel: { title: 'Lejek leadów', hint: 'wartość ważona {amount}', empty: 'Brak otwartych leadów.', conv: 'konwersja {pct}', note: 'Skuteczność 12 mies.: {win} · średni czas do wygranej {days} · bez ruchu 14+ dni: {idle}', daysShort: '{n} dni' },
  },
  finance: {
    aging: { title: 'Należności — wiekowanie w czasie', hint: 'portfel i po terminie', aria: 'Należności w czasie: w terminie i po terminie', onTime: 'W terminie', overdue: 'Po terminie', pct: '% po terminie', current: 'Stan na dziś', dso: 'DSO', cei: 'CEI', days: '{n} dni' },
    debtors: { title: 'Najwięksi dłużnicy', empty: 'Brak zaległości.', days: '{n} dni' },
    waterfall: { title: 'Wodospad marży', hint: 'wpływ czynników', aria: 'Wodospad marży: wpływ czynników na wynik', empty: 'Brak danych do wodospadu.', value: 'Wartość', pctOfSales: '% sprzedaży', level: 'Poziom po kroku' },
  },
  team: {
    title: 'Ranking zespołu',
    sales: 'Sprzedaż',
    realization: 'Realizacja',
    margin: 'Marża',
    trend: 'Trend 8 tyg.',
    trendUp: 'rośnie {pct}',
    trendDown: 'spada {pct}',
    trendFlat: 'bez zmian',
    empty: 'Brak danych o zespole.',
    profit: {
      title: 'Rentowność po kosztach',
      hint: 'top / bottom 5',
      customers: 'Klienci',
      routes: 'Trasy',
      best: 'Najlepsze',
      worst: 'Najsłabsze',
      noCosts: 'Zysk po kosztach jest niedostępny (brak uprawnienia lub kosztów) — pokazujemy marżę.',
      empty: 'Brak danych o rentowności.',
      switchAria: 'Klienci lub trasy',
    },
  },
  export: {
    columns: { section: 'Sekcja', item: 'Pozycja', value: 'Wartość', extra: 'Dodatkowo' },
    file: 'pulpit-menedzera',
  },
};

export const odV3En: typeof odV3Pl = {
  unavailableShort: 'Data unavailable',
  more: 'Details →',
  toolbar: {
    range: 'Time range',
    compare: 'Comparison',
    from: 'From',
    to: 'To',
    invalid: 'Pick a valid date range (from ≤ to).',
    viewMenu: 'View',
    layout: 'My layout',
    layoutHint: 'The chosen sections are remembered on this device.',
    resetLayout: 'Show all sections',
    presentation: 'Presentation mode',
    exitPresentation: 'Exit presentation (Esc)',
    exportExcel: 'Excel (CSV)',
    exportPdf: 'PDF for the board',
    exported: 'Dashboard data file saved.',
  },
  range: { month: 'Month', quarter: 'Quarter', year: 'Year', custom: 'Custom range' },
  compare: { prev: 'vs previous period', yoy: 'vs last year', none: 'no comparison' },
  sections: {
    forecast: 'Result and forecast',
    sales: 'Sales and products',
    customers: 'Customers and leads',
    finance: 'Finance',
    team: 'Team and profitability',
    operations: 'Operations and system',
  },
  health: {
    title: 'Company health',
    aria: 'Company health score: {score} out of 100, {tone}',
    vsPrev: '{delta} pts vs previous period',
    noScore: 'Not enough data to rate the company.',
    components: 'What it is made of',
    how: 'How is it calculated?',
    howText: 'A weighted average of five components: sales vs target, margin, receivables, customer base and field work. A component without data is skipped and the weights are rescaled.',
    weight: 'weight {n}%',
    tone: { ok: 'good', warn: 'needs attention', bad: 'critical', neutral: 'not rated' },
    comp: { sales: 'Sales vs target', margin: 'Margin', receivables: 'Receivables', customers: 'Customer base', field: 'Field' },
  },
  pulse: {
    realization: 'Target attainment',
    forecast: 'End-of-month forecast',
    forecastNote: '{pct} of target',
    probability: 'Chance to hit target',
    workingDays: 'Working days left',
    needDaily: 'need {value}/day',
    margin: 'Margin',
    noTarget: 'no target',
  },
  kpi: {
    net: 'Net sales',
    marginAmount: '{amount} margin',
    aov: 'Average order value',
    aovNote: '{count} orders',
    ordersDay: 'Orders / day',
    ordersDayNote: '{count} in range',
    vsPrev: '{delta} vs previous period',
    vsYoy: '{delta} vs last year',
  },
  main: {
    title: 'Sales over time',
    hint: 'Hover the chart to see a day; click a point to pin it.',
    tabs: { cum: 'Cumulative', margin: 'Margin', yoy: 'Year over year' },
    tabsAria: 'Chart type',
    metricAria: 'Chart measure',
    metric: { net: 'Net sales', margin: 'Margin', orders: 'Orders' },
    legend: { actual: 'Actual', forecast: 'Forecast', band: '80% band', target: 'Target', prev: 'Prev. period', yoy: 'Last year', daily: 'Daily', prevYear: 'Prev. year', margin: 'Margin %', avg: 'Average' },
    rangeNote: 'Target and forecast refer to the current month — for this range we show cumulative values with the comparison.',
    metricNote: 'Target and forecast are available for net sales only.',
    aria: 'Chart: {title}. {summary}',
    summary: 'To date {value}, days in range: {days}.',
    tip: { vsTarget: 'vs target', vsCompare: 'vs comparison', daily: 'Daily', cumulative: 'Cumulative' },
    picked: 'Day {date}: {metric} {value}, cumulative {cum}.',
    empty: 'No data for the selected range.',
  },
  scen: {
    title: 'End-of-month scenarios',
    pessimistic: 'Pessimistic',
    base: 'Base',
    optimistic: 'Optimistic',
    ofTarget: '{pct} of target',
    chance: 'chance {pct}',
    need: 'You are {missing} short of the target. At an average of {avg}/day you need {req}/day over {days} working days ({over} above the current pace).',
    needShort: 'You are {missing} short of the target; you need {req}/day over {days} working days.',
    reached: 'This month’s target is already reached — every further sale is surplus.',
    noTarget: 'No target for this month — the scenarios show the sales forecast only.',
  },
  sales: {
    groups: { title: 'Product groups', hint: 'sales · margin · change', empty: 'No sales in groups.', margin: 'margin {pct}' },
    pareto: {
      title: 'Customer structure (ABC / Pareto)',
      hint: 'top 10 concentration = {pct}',
      aria: 'Pareto curve: share of sales by share of customers',
      note: '20% of customers ({count}) bring {pct} of sales. Just {n50} customers make up 50% of sales.',
      toneOk: 'normal',
      toneWarn: 'elevated',
      toneBad: 'high concentration',
      threshold: 'Concentration warning threshold: 50% (top 10).',
      cum: 'Cumulative sales',
      customersPct: '% of customers',
    },
    heat: { title: 'Seasonality: when we sell', hint: 'weekday × week', less: 'less', more: 'more', aria: 'Sales heatmap: weekday and week', cell: '{day}, week of {week}: {value}' },
    next: { title: 'Forecast for the coming months', hint: '80% band', aria: 'Sales forecast for the coming months with an 80% band', value: 'Forecast', low: 'Lower bound', high: 'Upper bound', empty: 'No forecast.' },
  },
  customers: {
    flow: { title: 'Customer base health', hint: '12 mo.', aria: 'Customer flow: new, lost, recovered', newC: 'New', lost: 'Lost', recovered: 'Recovered', net: 'Net' },
    cohort: { title: 'Cohort retention', hint: '% of customers returning', size: 'Customers', month: 'M{n}', avg: 'Average 3-month retention: {pct}', empty: 'Not enough data for cohorts.' },
    churn: { title: 'At risk of leaving', hint: 'amount at risk {amount}', empty: 'No customers at risk.', more: 'Customers →', band: { HIGH: 'high', MEDIUM: 'medium', LOW: 'low' } },
    funnel: { title: 'Lead funnel', hint: 'weighted value {amount}', empty: 'No open leads.', conv: 'conversion {pct}', note: 'Win rate 12 mo.: {win} · average time to win {days} · idle 14+ days: {idle}', daysShort: '{n} days' },
  },
  finance: {
    aging: { title: 'Receivables — aging over time', hint: 'portfolio and overdue', aria: 'Receivables over time: on time and overdue', onTime: 'On time', overdue: 'Overdue', pct: 'Overdue %', current: 'As of today', dso: 'DSO', cei: 'CEI', days: '{n} days' },
    debtors: { title: 'Largest debtors', empty: 'No overdue amounts.', days: '{n} days' },
    waterfall: { title: 'Margin waterfall', hint: 'impact of factors', aria: 'Margin waterfall: impact of factors on the result', empty: 'No data for the waterfall.', value: 'Value', pctOfSales: '% of sales', level: 'Level after step' },
  },
  team: {
    title: 'Team ranking',
    sales: 'Sales',
    realization: 'Attainment',
    margin: 'Margin',
    trend: '8-week trend',
    trendUp: 'up {pct}',
    trendDown: 'down {pct}',
    trendFlat: 'flat',
    empty: 'No team data.',
    profit: {
      title: 'Profitability after costs',
      hint: 'top / bottom 5',
      customers: 'Customers',
      routes: 'Routes',
      best: 'Best',
      worst: 'Weakest',
      noCosts: 'Profit after costs is unavailable (missing permission or costs) — showing margin.',
      empty: 'No profitability data.',
      switchAria: 'Customers or routes',
    },
  },
  export: {
    columns: { section: 'Section', item: 'Item', value: 'Value', extra: 'Extra' },
    file: 'manager-dashboard',
  },
};
